export const CAPACCOUNT_QUERY_KEYS = {
  GET_CAPACCOUNT_INFO: 'GET_CAPACCOUNT_INFO',
  GET_CAPACCOUNT_TRANSFERS: 'GET_CAPACCOUNT_TRANSFERS',
  GET_CAPACCOUNT_STATEMENT: 'GET_CAPACCOUNT_STATEMNET',
  GET_CAPACCOUNT_STATEMENT_SPECIFIC: 'GET_CAPACCOUNT_STATEMNET_SPECIFIC',
};
